
import * as authHelper from "../core/AuthHelpers.ts"
import { getUserByToken } from "./_requests.ts"


import React, {
  useState,
  useEffect,
  createContext,
  useContext,
  useRef
} from "react"

const initAuthContextPropsState = {
  auth: authHelper.getAuth(),
  saveAuth: () => {},
  currentUser: undefined,
  setCurrentUser: () => {},
  logout: () => {},
  setLogIn: () => {},
  logIn: "",
  setLogOut: () => {},
  logOut: "",
  user: null,
  updatingUser: () => {}
}

const AuthContext = createContext(initAuthContextPropsState)

const useAuth = () => {
  return useContext(AuthContext)
}

const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(authHelper.getAuth())
  const [currentUser, setCurrentUser] = useState()
  const [logIn, setLogIn] = useState("")
  const [logOut, setLogOut] = useState("")
  const [user, setUser] = useState(null)
  const [showSplashScreen, setShowSplashScreen] = useState(true)

  const saveAuth = auth => {
    setAuth(auth)
    if (auth) {
      authHelper.setAuth(auth)
    } else {
      authHelper.removeAuth()
    }
  }

  const logout = () => {
    saveAuth(undefined)
    setCurrentUser(undefined)
    setUser(null)
    // SEC-06: Clear all sensitive session data on logout
    sessionStorage.removeItem("token")
    sessionStorage.removeItem("is_auth")
    sessionStorage.removeItem("user")
    sessionStorage.removeItem("refreshToken")
    sessionStorage.removeItem("MainApp")
  }

  const updatingUser = data => setUser(data)

  const didRequest = useRef(false)

  useEffect(() => {
    const requestUser = async apiToken => {
      try {
        if (!didRequest.current) {
          const { data } = await getUserByToken(apiToken)
          if (data) {
            setCurrentUser(data)
            updatingUser(data)
          }
        }
      } catch (error) {
        console.error(error)
        if (!didRequest.current) {
          logout()
        }
      } finally {
        setShowSplashScreen(false)
      }
    }

    if (auth && auth.token) {
      requestUser(auth.token)
    } else {
      logout()
      setShowSplashScreen(false)
    }

    return () => {
      didRequest.current = true
    }
  }, [auth])

  return (
    <AuthContext.Provider
      value={{
        auth,
        saveAuth,
        currentUser,
        setCurrentUser,
        logout,
        logIn,
        setLogIn,
        logOut,
        setLogOut,
        user,
        updatingUser
      }}
    >
      {!showSplashScreen && children}
    </AuthContext.Provider>
  )
}

const AuthInit = ({ children }) => {
  const { auth, logout, setCurrentUser } = useAuth()
  const didRequest = useRef(false)
  const [showSplashScreen, setShowSplashScreen] = useState(true)

  useEffect(() => {
    const requestUser = async apiToken => {
      try {
        if (!didRequest.current) {
          const { data } = await getUserByToken(apiToken)
          if (data) {
            setCurrentUser(data)
          }
        }
      } catch (error) {
        console.error(error)
        if (!didRequest.current) {
          logout()
        }
      } finally {
        setShowSplashScreen(false)
      }
    }

    if (auth && auth.token) {
      requestUser(auth.token)
    } else {
      logout()
      setShowSplashScreen(false)
    }

    return () => {
      didRequest.current = true
    }
  }, [auth])

  return !showSplashScreen ? <>{children}</> : null
}

export { AuthProvider, AuthInit, useAuth }
